import { z } from 'zod';
import { moneySchema } from './schemas.js';

export const fixedAssetCategorySchema = z.object({
  name: z.string().min(1).max(120),
  method: z.enum(['straight_line', 'declining_balance']).default('straight_line'),
  usefulLifeMonths: z.number().int().min(1).max(600).default(60)
});

export const fixedAssetSchema = z.object({
  name: z.string().min(1).max(200),
  categoryId: z.string().min(1),
  acquisitionDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  cost: moneySchema,
  salvageValue: moneySchema.default('0.00'),
  status: z.enum(['active', 'disposed']).default('active')
});

export const payRunLineSchema = z.object({
  label: z.string().min(1).max(120),
  earnings: moneySchema.default('0.00'),
  deductions: moneySchema.default('0.00')
});

export const payRunSchema = z.object({
  periodId: z.string().min(1),
  payDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  memo: z.string().max(500).optional(),
  lines: z.array(payRunLineSchema).min(1)
});
